<template>
	<div class="steps__step-form">
		<form
			class="form form--fixed-fields"
			@submit.prevent="updateForm"
		>
			<div class="form__set form__set--wrap">
				<InputComponent
					:value="form_fields.currency"
					type="select"
					input-id="currency"
					name="currency"
					label="Currency"
					:options="currencies"
					:required="true"
					:errors="form_errors.currency || null"
					@update:value="new_value => form_fields.currency = new_value"
				/>
			</div>


			<template v-if="scope">
				<h4 class="h5 h5--b">
					Project Deliverables
				</h4>
				<h3 class="h5">
					<span v-if="scope.sequence_prefix">
						{{ scope.sequence_prefix }}&nbsp;
					</span>
					<span
						v-if="scope.sequence_prefix"
						class="light"
					>
						&mdash;&nbsp;
					</span>
					<span class="light">
						{{ scope.title }}
					</span>
				</h3>

				<ProjectDeliverableComponent
					v-for="item, index in scope.items"
					:key="'scope-item' + index"
					:deliverable="item"
					:currency="selected_currency"
				/>
			</template>

			<button
				class="button button--fill"
				type="submit"
			>
				Save {{ stepTitle }}
			</button>
		</form>
	</div>
</template>

<script setup>
import { useAddProjectScopeStore } from '../../stores/add-project-scope.js';
import { ref, computed, defineProps, defineEmits, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';
import ProjectDeliverableComponent from '../ProjectDeliverableComponent';

const add_project_scope_store = useAddProjectScopeStore();
const { getCurrencies } = add_project_scope_store;
const {
	project,
	form_fields,
	form_errors,
	currencies
} = storeToRefs( add_project_scope_store );

const emit = defineEmits( ['complete-form'] );

defineProps( {
	stepTitle: {
		required: true,
		type: String,
		default: ''
	}
} );

const loading = ref( true );

onMounted ( async() => {
	await getCurrencies();

	loading.value = false;
} );

const selected_currency = computed( () => {
	return currencies.value.find( currency => parseInt( currency.value ) === parseInt( form_fields.value.currency ) );
} );

async function updateForm() {
	form_errors.value = {};

	if ( !form_fields.value.currency ) {
		form_errors.value['currency'] = 'Please select a currency';
		return;
	}

	emit( 'complete-form' );
}

const scope = computed( () => {
	return form_fields.value.project_scope ?? null;
} );
</script>
